var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDown = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 9.4 20.9",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.8.4 3.7 17l-2.3-2.3L0 16.1l4.7 4.8 4.7-4.8L8 14.7 5.7 17 5.8.4z",
  className: "st0"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-down.34051c876c9d3e04e4843999ca5938dd.svg";